import { render, staticRenderFns } from "./dialog-look.vue?vue&type=template&id=7079b7ea&scoped=true&"
import script from "./dialog-look.vue?vue&type=script&lang=js&"
export * from "./dialog-look.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7079b7ea",
  null
  
)

export default component.exports